import React, { createContext, useContext, useState } from 'react';

const TransactionContext = createContext();

export const useTransactionContext = () => {
  const context = useContext(TransactionContext);
  if (!context) {
    throw new Error('useTransactionContext must be used within a TransactionProvider');
  }
  return context;
};

export const TransactionProvider = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const triggerRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <TransactionContext.Provider value={{ refreshTrigger, triggerRefresh }}>
      {children}
    </TransactionContext.Provider>
  );
};
